import {
  IconButton,
  IconButtonProps,
  styled,
  SvgIconProps,
} from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "iconColor",
})<{ iconColor?: string }>(({ theme, iconColor }) => ({
  color: iconColor ?? theme.palette.text.black,
  padding: 0,
}));

const StyledNavigateBeforeIcon = styled(NavigateBeforeIcon)<SvgIconProps>(
  () => ({
    fontSize: "30px",
  })
);

interface Props extends IconButtonProps {
  iconProps?: SvgIconProps;
  iconColor?: string;
}

export const NavigateBeforeButton: React.FC<Props> = ({
  iconProps,
  iconColor,
  ...buttonProps
}) => {
  return (
    <StyledIconButton {...buttonProps} iconColor={iconColor}>
      <StyledNavigateBeforeIcon {...iconProps} />
    </StyledIconButton>
  );
};
